import {
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Typography,
} from '@mui/material';
import FileUpload from 'src/app/components/FileUpload';
import UploadedFile from 'src/app/components/UploadedFile';
import { useState } from 'react';
import { FormikProps } from 'formik';
import { AddFromSpreadsheetFormValues } from './AddProductsFromSpreadsheet';
import { read } from 'xlsx';
import { TableChart } from '@mui/icons-material';

const UploadASpreadsheet = ({
  values,
  setFieldValue,
}: FormikProps<AddFromSpreadsheetFormValues>) => {
  const [spreadsheet, setSpreadsheet] = useState<File | null>(null);
  const [isParsing, setIsParsing] = useState(false);

  const parseSpreadsheet = async () => {
    if (!spreadsheet) return false;
    const workbook = read(await spreadsheet.arrayBuffer());
    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    setFieldValue('spreadsheet', worksheet);
    return true;
  };

  const exampleSpreadsheet =
    'SKU,Price,Title,Description,Categories\nSKU123,10,Product 1,This is a description,Example Category';

  return (
    <Stack>
      <Typography variant="h4">Upload your spreadsheet</Typography>
      <FileUpload
        maxFiles={1}
        minSize={0} // leave this?
        label="Drag and drop or click here to upload."
        fileTypeDescription=".CSV, .XLS, or .XLSX spreadsheets accepted."
        accept={{
          'text/csv': ['.csv'],
          'application/vnd.ms-excel': ['.xls'],
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
            '.xlsx',
          ],
        }}
        onDropAccepted={(files: File[]) => {
          setSpreadsheet(files[0]);
        }}
        onDropRejected={(files) => console.log(files)} // TODO
      />
      {spreadsheet ? (
        <UploadedFile
          file={spreadsheet}
          uploaded={true}
          isUploading={false}
          error={undefined} // todo
          onClear={() => {
            setSpreadsheet(null);
          }}
        />
      ) : (
        <Card
          sx={{
            my: 2,
            backgroundColor: 'primary.light',
            border: 'none',
            boxShadow: '0px 4px 14px 0px rgba(0, 0, 0, 0.10)',
          }}
        >
          <CardContent>
            <Stack direction="row" justifyContent="space-between">
              <Box>
                <Typography fontWeight={700}>Table Example</Typography>
                <Typography>
                  You can download the attached example and use it as a starting
                  point for your own file.
                </Typography>
              </Box>
              <Button
                variant="flat"
                startIcon={<TableChart />}
                onClick={() => {
                  const blob = new Blob([exampleSpreadsheet], {
                    type: 'text/csv;charset=utf-8;',
                  });
                  const link = document.createElement('a');
                  const url = URL.createObjectURL(blob);
                  link.setAttribute('href', url);
                  link.setAttribute(
                    'download',
                    'Example Catalog Product Spreadsheet.csv'
                  );
                  link.style.visibility = 'hidden';
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                }}
              >
                Download
              </Button>
            </Stack>
          </CardContent>
        </Card>
      )}
      <Box alignSelf="flex-end">
        <Button
          variant="flat"
          onClick={async () => {
            setIsParsing(true);
            await parseSpreadsheet();
            setIsParsing(false);
            setFieldValue('activeStep', 1);
          }}
          disabled={!spreadsheet}
        >
          {isParsing ? 'loading' : 'Next'}
        </Button>
      </Box>
    </Stack>
  );
};

export default UploadASpreadsheet;
